import React from 'react';
import I18n from 'app/i18n';

interface Props {
  cancelByUser: boolean;
  cancelByAdmin: boolean;
}

const RenderState: React.FC<Props> = (props: Props): React.ReactNode => {
    if (props.cancelByUser) {
        return <span className="color-gray">{I18n.t('canceled_by_user')}</span>;
    } else if (props.cancelByAdmin) {
        return <span className="color-gray">{I18n.t('canceled_by_admin')}</span>;
    }

    return <></>;
};

export default RenderState;
